import i from './container-tracking.container';

export default i;
